import React, { useState } from 'react';
import { 
  User, Globe, Mic, GraduationCap, DollarSign, Building, 
  Briefcase, Heart, Users, HandHeart, Laptop, Palette,
  Building2, Newspaper, HelpCircle, ChevronDown
} from 'lucide-react';
import { mockFormSubmit } from '../mock';
import { toast } from 'sonner';

export const GetInvolvedSection = () => {
  const [openItem, setOpenItem] = useState(null);

  const pathways = [
    {
      id: 1,
      icon: User,
      title: 'Become a Lady Hustler',
      content: 'Join a global association of women building businesses, careers, and economic independence. Membership provides access to education, incubator pathways, global networking, and participation in women-led economic and humanitarian initiatives.',
      cta: 'Become a Lady Hustler',
      link: 'https://entrepreneurladyhustler.com/en/become-a-lady-hustler/'
    },
    {
      id: 2,
      icon: Globe,
      title: 'Closing the Gap Campaign',
      content: 'A global women-led campaign delivering humanitarian aid and economic empowerment in 25+ countries. Its innovative same-day redistribution model eliminates warehouses, waiting periods, and bureaucracy. Local city squads partner directly with community businesses to collect and immediately redistribute surplus essentials to women, families, and organizations in need. Women are not just beneficiaries — they become active participants, fostering agency and self-reliance. Community-funded. Women-led.',
      cta: 'Explore the Campaign',
      link: 'https://entrepreneurladyhustler.com/en/closing-the-gap-womens-humanitarian-campaign/'
    },
    {
      id: 3,
      icon: Mic,
      title: 'Lend Your Voice — Speakers & Thought Leaders',
      content: 'Contribute as a speaker, facilitator, panelist, or community thought partner. Formats include keynote addresses, panel discussions, skill-building workshops, fireside chats, and community roundtables. We value authentic storytelling and lived experiences above all else. Speakers are compensated and receive full production support. Topics include: women\'s entrepreneurship, economic justice, leadership development, breaking barriers in business, financial literacy, and community organizing.',
      cta: 'Apply to Speak',
      link: 'https://entrepreneurladyhustler.com/en/for-speakers-panelists-and-thought-leaders/'
    },
    {
      id: 4,
      icon: GraduationCap,
      title: 'Campus Activations — Universities, Incubators & Accelerators',
      content: 'Co-create educational activations connecting students and alumni to women-led entrepreneurship, professional development, and global impact. Our partnerships are flexible, practical, and impact-driven.',
      cta: 'Book a Campus Activation',
      link: 'https://entrepreneurladyhustler.com/en/campus-activation-request/'
    },
    {
      id: 5,
      icon: DollarSign,
      title: 'Investor & Funder Engagement',
      content: 'LHSC is not an investor marketplace. We are a business incubator and economic engine. We micro-fund, prepare, and de-risk early-stage female-led businesses before they ever meet external capital.',
      cta: 'Invest or Fund a Lady Hustler',
      link: 'https://entrepreneurladyhustler.com/en/investor-funder-intake/'
    },
    {
      id: 6,
      icon: Building,
      title: 'Corporations & Sponsors',
      content: 'Fund city activations through our tiered sponsorship model. Activate the Women\'s Empowerment Principles through real action. Gain visibility across 25+ countries and align with UN standards.',
      cta: 'Contact us for Partnership Deck',
      link: 'https://entrepreneurladyhustler.com/en/become-an-investor-sponsor/'
    },
    {
      id: 7,
      icon: Briefcase,
      title: 'Businesses & Local Partners',
      content: 'Join our hyper-local redistribution network. Donate surplus goods through your café, salon, bakery, or clinic. Sign the WEPs. Volunteer your team.',
      cta: 'Become a Redistribution Partner',
      link: 'https://entrepreneurladyhustler.com/en/strategic-partnership-inquiry/'
    },
    {
      id: 8,
      icon: Heart,
      title: 'Donors & Philanthropists',
      content: 'Your contribution funds education, humanitarian redistribution, micro-grants, and operational sustainability. 100% of our funding flows directly to women.',
      cta: 'Donate Today',
      link: 'https://entrepreneurladyhustler.com/en/strategic-partnership-inquiry/'
    },
    {
      id: 9,
      icon: Users,
      title: 'Volunteers & Co-Creators',
      content: 'Activate Closing the Gap in your city. Receive training, safeguarding support, and field stipends ($60/day for up to 2 activation days per month).',
      cta: 'Volunteer With Us',
      link: 'https://docs.google.com/forms/d/e/1FAIpQLSfZCS6ey74o1BCchyhOOTjI5MlK1O_4gem1nPS69HLROzBbQA/viewform'
    },
    {
      id: 10,
      icon: HandHeart,
      title: 'Community & Nonprofit Partnerships',
      content: 'Rooted in dignity and consent. Designed for community-led organizations, nonprofits, online communities, collectives, grassroots groups, and aligned networks.',
      cta: 'Connect as a Community Partner',
      link: 'https://entrepreneurladyhustler.com/en/community-partner/'
    },
    {
      id: 11,
      icon: Building2,
      title: 'Redistribution Network — Nonprofits, Shelters & Community Organizations',
      content: 'Join our dignity-first Redistribution Network. Same-day redistribution of essential goods directly to those in need.',
      cta: 'Join a Redistribution Network',
      link: 'https://entrepreneurladyhustler.com/en/join-the-lhsc-redistribution-network/'
    },
    {
      id: 12,
      icon: Laptop,
      title: 'Hire Women-Led Talent',
      content: 'Access vetted women-led professionals across creative, digital, strategic, and operational fields — while supporting a nonprofit economic ecosystem.',
      cta: 'Post a Job or Project',
      link: 'https://entrepreneurladyhustler.com/en/for-companies-agencies-seeking-talents/'
    },
    {
      id: 13,
      icon: Palette,
      title: 'Digital Professionals & Creatives Seeking Opportunities',
      content: 'Are you a designer, developer, writer, translator, or creative professional? Join our referral network.',
      cta: 'Join as a Professional Member',
      link: 'https://entrepreneurladyhustler.com/en/become-a-lady-hustler/'
    },
    {
      id: 14,
      icon: Globe,
      title: 'International Organizations & Institutions',
      content: 'We\'re listed on the UN Partner Portal and built to meet international institutional standards.',
      cta: 'Explore Institutional Partnerships',
      link: 'https://entrepreneurladyhustler.com/en/university-incubator-partnerships/'
    },
    {
      id: 15,
      icon: Newspaper,
      title: 'Media, Journalists & Storytellers',
      content: 'Document our street campaigns. Interview our members. Amplify ethical, dignity-first storytelling.',
      cta: 'Media Inquiries',
      link: 'mailto:hello@entrepreneurladyhustler.com'
    },
    {
      id: 16,
      icon: HelpCircle,
      title: 'Not Sure Where You Fit?',
      content: 'Some collaborations begin with clarity. Others begin with curiosity. Every connection has the potential to close a gap.',
      cta: 'Contact Us',
      link: 'mailto:hello@entrepreneurladyhustler.com'
    }
  ];

  const handleSubmit = async (link) => {
    if (link.startsWith('mailto:')) {
      window.location.href = link;
    } else if (link.startsWith('#')) {
      const element = document.querySelector(link);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      window.open(link, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <section id="get-involved" className="py-20" style={{ backgroundColor: 'var(--pink-blush)' }}>
      <div className="max-w-6xl mx-auto px-6">
        {/* Section Header */}
        <div className="mb-12">
          <h2 className="lhsc-heading text-3xl md:text-5xl mb-6 text-center">
            EVERY ROLE MATTERS. EVERY CONNECTION COUNTS.
          </h2>
          <div className="lhsc-body max-w-4xl mx-auto">
            <p>
              The Lady Hustler Society Club is a Canadian nonprofit association based in Quebec, operating internationally 
              to advance women's economic empowerment through education, entrepreneurship, and community-led humanitarian action. 
              We bring together female entrepreneurs, professionals, institutions, companies, nonprofits, and global partners who 
              believe that economic equity requires both opportunity and action.
            </p>
          </div>
        </div>

        {/* Accordion */}
        <div className="space-y-4">
          {pathways.map((pathway) => (
            <div
              key={pathway.id}
              className="bg-white border border-[var(--pink-dusty)] overflow-hidden"
            >
              <button
                onClick={() => setOpenItem(openItem === pathway.id ? null : pathway.id)}
                className="w-full p-6 flex items-center justify-between text-left hover:bg-[var(--pink-blush)] transition-colors"
              >
                <div className="flex items-center flex-1">
                  <pathway.icon size={24} className="mr-4" style={{ color: 'var(--mauve-rose)' }} />
                  <h3 className="lhsc-heading text-base md:text-lg">{pathway.title}</h3>
                </div>
                <ChevronDown
                  size={24}
                  className="transition-transform flex-shrink-0"
                  style={{
                    color: 'var(--mauve-rose)',
                    transform: openItem === pathway.id ? 'rotate(180deg)' : 'rotate(0deg)'
                  }}
                />
              </button>

              {openItem === pathway.id && (
                <div className="p-6 pt-0 border-t border-[var(--pink-dusty)]">
                  <div className="lhsc-body text-sm mb-6 whitespace-pre-line">
                    {pathway.content}
                  </div>
                  <button
                    onClick={() => handleSubmit(pathway.link)}
                    className="px-6 py-3 rounded-md text-white font-semibold text-sm tracking-wider"
                    style={{ 
                      backgroundColor: 'var(--mauve-rose)',
                      fontFamily: 'Josefin Sans, sans-serif',
                      textTransform: 'uppercase',
                      letterSpacing: '0.1em',
                      fontWeight: 500
                    }}
                  >
                    {pathway.cta} →
                  </button>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
